import React from "react";
import { motion } from "framer-motion";

const SuccessTimeline = ({ extension }) => {
  const steps = extension.process || [];

  return (
    <motion.div
      key="process"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      {/* Section Header */}
      <div className="text-center mb-5">
        <span className="badge mb-3 px-3 py-2 bg-success bg-gradient text-light fs-6">
          Our Process
        </span>
        <h2
          className="display-5 fw-bold text-success"
          style={{
            background: "linear-gradient(to right, #16a34a, #065f46)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          5-Step Success Timeline
        </h2>
        <p className="lead text-muted mx-auto" style={{ maxWidth: "720px" }}>
          Our proven methodology ensures successful project delivery with clear
          milestones.
        </p>
      </div>

      <div className="position-relative">
        {/* Vertical timeline line for large screens */}
        <div
          className="d-none d-lg-block position-absolute start-50 translate-middle-x"
          style={{
            left: "50%",
            top: 0,
            transform: "translateX(-50%)",
            width: "4px",
            height: "100%",
            background: "linear-gradient(to bottom, #34D399, #059669)",
            borderRadius: "2px",
            zIndex: 0,
          }}
        ></div>

        <div className="d-flex flex-column gap-5">
          {steps.map((step, index) => {
            const isEven = index % 2 === 0;
            return (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, x: isEven ? -40 : 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className={`d-flex flex-column flex-lg-row ${
                  !isEven ? "flex-lg-row-reverse" : ""
                } align-items-center justify-content-between`}
                style={{
                  margin: '0 40px'
                }}
              >
                {/* Step Card */}
                <div className="col-lg-6 col-12">
                  <div
                    className="card shadow-lg border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(to bottom right, #ffffff, #f0fdf4)",
                      border: "1px solid rgba(34,197,94,0.3)",
                      marginRight: isEven ? '20px' : 0,
                      marginLeft: !isEven ? '20px' : 0
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="d-flex justify-content-center align-items-center rounded-circle text-white me-3"
                          style={{
                            width: "40px",
                            height: "40px",
                            background:
                              "linear-gradient(to right, #10b981, #059669)",
                            fontWeight: "bold",
                          }}
                        >
                          {index + 1}
                        </div>
                        <h3 className="h4 fw-bold text-success mb-0">
                          {step.step}
                        </h3>
                      </div>
                      <p className="text-muted mb-3">{step.description}</p>
                      <div className="d-flex align-items-center text-success small">
                        <i className="bi bi-clock me-2" />
                        Duration: {step.duration}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Timeline Dot */}
                <div
                  className="position-absolute d-none d-lg-block"
                  style={{
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1
                  }}
                >
                  <div
                    className="bg-success rounded-circle border border-white shadow"
                    style={{
                      width: "15px",
                      height: "15px",
                      borderWidth: "8px",
                    }}
                  ></div>
                </div>

                {/* Empty div to balance layout */}
                <div className="col-lg-6 col-12 d-none d-lg-block"></div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default SuccessTimeline;
